import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterXActiveIcon, FilterXIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

export interface FilterXIconButtonProps extends ExtendedIconButtonProps {
  isActive?: boolean;
}

const styles = {
  root: {
    '&:hover path, &:focus-visible path': {
      fill: 'inherit',
    },
    ':disabled': {
      backgroundColor: 'transparent',
    },
  },
};

const FilterXIconButton = forwardRef<HTMLButtonElement, FilterXIconButtonProps>(
  ({ isActive = false, tooltipTitle, ...props }, ref) => {
    const { t } = useTranslation();
    const resolvedTooltipTitle =
      tooltipTitle ?? t('common.reset_filters', 'Reset filters');

    return (
      <IconButton
        ref={ref}
        {...props}
        tooltipTitle={resolvedTooltipTitle}
        sx={{ ...styles.root, ...props.sx }}
      >
        {isActive ? (
          <FilterXActiveIcon />
        ) : (
          <FilterXIcon />
        )}
      </IconButton>
    );
  },
);

FilterXIconButton.displayName = 'FilterXIconButton';
export default FilterXIconButton;
